// actions.js
// Action types for jobdetails data fetching request, success, and failure
export const FETCH_JOB_DETAILS_REQUEST = "FETCH_JOB_DETAILS_REQUEST";
export const FETCH_JOB_DETAILS_SUCCESS = "FETCH_JOB_DETAILS_SUCCESS";
export const FETCH_JOB_DETAILS_FAILURE = "FETCH_JOB_DETAILS_FAILURE";

// Action creator for jobdetails data fetching request
export const fetchJobDetailsRequest = (payload) => ({
  type: FETCH_JOB_DETAILS_REQUEST,
  payload
});

// Action creator for jobdetails data fetching success
export const fetchJobDetailsSuccess = (isJobDetailsItem) => ({
  type: FETCH_JOB_DETAILS_SUCCESS,
  payload: isJobDetailsItem,
});

// Action creator for jobdetails data fetching failure
export const fetchJobDetailsFailure = (error) => ({
  type: FETCH_JOB_DETAILS_FAILURE,
  payload: error,
});
